import { IProfile } from '@/types/profile'
import { AppCode, Team, TeamWritePayload } from '@/types/auth'

/**
 * `appCode` comes in as a plain `string` (from `settings.app.code`, which
 * isn't narrowed to `AppCode`) — the cast is honest here: it's always one
 * of the 4 real app codes at runtime, just not typed that way yet.
 */
export function getProfileTeams(profile: IProfile | undefined, appCode: string): Team[] {
  return profile?.teams?.[appCode as AppCode] || []
}

export function getFavoriteTeam(profile: IProfile | undefined, appCode: string): Team | null {
  return getProfileTeams(profile, appCode).find((team) => team.favorite) ?? null
}

/**
 * Write payload for `PATCH profile.teams`: the profile service only accepts
 * `{_id, favorite}` and rebuilds the verified snapshot server-side — anything
 * else sent from the browser is discarded there, so sending it is noise.
 */
export function toTeamWritePayload(team: Pick<Team, '_id'>, favorite: boolean): TeamWritePayload {
  return { _id: team._id, favorite }
}
